<body>
    <div class="main">
        <div class="sideBar">
            
        </div>
        <div class="contentContainer">
            <div class="RequestTypeContainer">
                <span class="header_font" style="color: #0564B1;">Outing Application Status</span>
                <div class="btnContainer">
                    <button class="btn"> + New Request </button>
                    <!-- <button class="btn">Bulk</button> -->
                </div>
            </div>
            <div class="tableContainer">
                <input type="text " class="input " (input)="onQuickFilterChanged($event)" placeholder="Search..." />
                <ag-grid-angular style="width: 98%; height:88%; overflow: auto; margin-left: 1%;"
                    [rowData]="rowData" [pinnedTopRowData]="pinnedTopRowData" [columnDefs]="colDefs"
                    [defaultColDef]="defaultColDef" [quickFilterText]="quickFilter" />
            </div>
        </div>
    </div>
</body>